import PromptTemplateDataTable from '../components/PromptTemplateDataTable';

export default function WordGroupPrompts() {
  return <PromptTemplateDataTable templateType="word_group" />;
}
